/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPlusColumnTop: {
  name: 'plus-column-top';
  data: string;
} = {
  name: 'plus-column-top',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 .5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h3.5V9a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V7.5H15a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5H1Zm3.5 1h-3v5h3v-5Zm7 0v5h3v-5h-3Zm-1 5.5V1.5h-5v7h5V7ZM8 10.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V15a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V11a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
